<template>
  <div class="twolevel-container">
    <van-nav-bar 
      :title="this.groupInfo ? (this.groupInfo.type === 0 ? '所属推广组收益流水' : '二级充值流水(撩币)') : ''" 
      left-text="" 
      left-arrow
      @click-left="onClickLeft" 
      @click-right="onClickRight" 
      :title-style="{ color: '#ffffff', fontWeight: '600' }"
      :left-arrow-style="{ color: '#ffffff' }"
      :style="{ background: '#1a1a1a' }"
    />
    
    <div v-if="!!groupInfo" class="content-wrapper">
      <!-- 搜索区域 -->
      <div class="search-container">
        <van-search 
          v-model="search" 
          @search="onSearch" 
          shape="round" 
          show-action 
          placeholder="输入组长ID"
          :background="'transparent'"
          :input-style="{ backgroundColor: '#3a3a3a', borderRadius: '8px', color: '#ffffff' }"
        >
          <template #action>
            <div @click="onSearch" class="search-btn" style="color: #ffffff">搜索</div>
          </template>
        </van-search>
        
        <div class="search-filters">
          <div class="radio-group-wrapper">
            <van-radio-group v-model="checked" direction="horizontal">
              <van-radio name="0" icon-size="16px" class="radio-item">组长ID</van-radio>
              <van-radio name="1" icon-size="16px" class="radio-item">邀请组长ID</van-radio>
            </van-radio-group>
          </div>
          
          <van-dropdown-menu v-if="this.groupInfo && this.groupInfo.type === 0" 
            active-color="#ff9500"
            class="dropdown-wrapper"
          >
            <van-dropdown-item 
              v-model="incomeType" 
              :options="incomeTypes" 
              @change="onIncomeTypeChanged" 
              :style="{ fontSize: '14px' }"
            />
          </van-dropdown-menu>
        </div>
        
        <!-- 时间选择器 -->
        <div class="date-picker-container">
          <span class="date-label">时间范围：</span>
          <div 
            class="date-selector begin-date" 
            @click="onTimeBeginTapped"
          >
            {{ timeBeginDisplay }}
          </div>
          <span class="date-separator">至</span>
          <div 
            class="date-selector end-date" 
            @click="onTimeEndTapped"
          >
            {{ timeEndDisplay }}
          </div>
        </div>
      </div>
      
      <!-- 数据列表 -->
      <van-list 
        class="transaction-list" 
        v-model:loading="loading" 
        :immediate-check="false" 
        :finished="finished"
        finished-text="没有更多了" 
        @load="onLoad"
        :offset="100"
      >
        <div class="transaction-card" v-for="(li, i) in list" :key="i">
          <div class="transaction-content" v-if="li.secondIncome >= 0">
            <!-- 财务数据展示 -->
            <div class="finance-details">
              <div class="finance-item">
                <span class="finance-label">流水金额</span>
                <span class="finance-value primary-value">{{ li.num }}</span>
              </div>
              
              <div class="finance-item">
                <span class="finance-label">邀请组分成</span>
                <span class="finance-value secondary-value">{{ li.secondIncome }}</span>
              </div>
              
              <div class="finance-item" v-if="li.topOwnerIncome != 0 && li.isOneLevel">
                <span class="finance-label">一级组分成</span>
                <span class="finance-value tertiary-value">{{ li.topOwnerIncome }}</span>
              </div>
            </div>
            
            <!-- 底部信息 -->
            <div class="transaction-footer">
              <div class="transaction-time">{{ getDisplayTime(li.time) }}</div>
              <div class="transaction-source">来自{{ li.userId }}组的{{ li.transactionName }}</div>
            </div>
          </div>
        </div>
      </van-list>
      
      <!-- 日期选择弹窗 -->
      <van-popup v-model:show="showDatePicker" position="bottom" round>
        <van-datetime-picker 
          v-model="datePicker" 
          type="date" 
          title="选择日期" 
          :min-date="minDate" 
          :max-date="maxDate"
          @confirm="onDatePickerConfirm" 
          @cancel="onDatePickerCancel" 
        />
      </van-popup>
    </div>
    
    <!-- 统计数据区域 -->
    <div v-if="!!groupInfo" class="statistics-section fixed-bottom">
      <!-- 空状态 -->
      <div v-if="incomeList && incomeList.length === 0" class="empty-state">
        <div class="empty-icon">📊</div>
        <div class="empty-text">暂无相关流水数据</div>
      </div>
      
      <!-- 统计表格 -->
      <div v-else class="stats-table-container">
        <table class="stats-table">
          <thead>
            <tr>
              <th>流水类型</th>
              <th v-if="isColumnNotEmpty('totalIncome')">总金额</th>
              <th v-if="isColumnNotEmpty('parentShare')">邀请组分成</th>
              <th v-if="list.length>0 ?list[0].isOneLevel:false && isColumnNotEmpty('topOwnerIncome')">一级组长分成</th>
            </tr>
          </thead>
          <tbody>
            <!-- 收益流水 -->
            <tr v-if="isDiaplay(getIncomeByType(0))">
              <td>收益流水</td>
              <td v-if="isColumnNotEmpty('totalIncome')" class="highlight">{{ formatNumber(getIncomeByType(0).totalIncome) }}</td>
              <td v-if="isColumnNotEmpty('parentShare')">{{ formatNumber(getIncomeByType(0).parentShare) }}</td>
              <td v-if="list.length>0 ?list[0].isOneLevel:false && isColumnNotEmpty('topOwnerIncome')">{{ formatNumber(getIncomeByType(0).topOwnerIncome) }}</td>
            </tr>
            
            <!-- 充值流水 -->
            <tr v-if="isDiaplay(getIncomeByType(1))">
              <td>充值流水</td>
              <td v-if="isColumnNotEmpty('totalIncome')" class="highlight">{{ formatNumber(getIncomeByType(1).totalIncome) }}</td>
              <td v-if="isColumnNotEmpty('parentShare')">{{ formatNumber(getIncomeByType(1).parentShare) }}</td>
              <td v-if="list.length>0 ?list[0].isOneLevel:false && isColumnNotEmpty('topOwnerIncome')">{{ formatNumber(getIncomeByType(1).topOwnerIncome) }}</td>
            </tr>
            
            <!-- 会员流水 -->
            <tr v-if="isDiaplay(getIncomeByType(2))">
              <td>会员流水</td>
              <td v-if="isColumnNotEmpty('totalIncome')" class="highlight">{{ formatNumber(getIncomeByType(2).totalIncome) }}</td>
              <td v-if="isColumnNotEmpty('parentShare')">{{ formatNumber(getIncomeByType(2).parentShare) }}</td>
              <td v-if="list.length>0 ?list[0].isOneLevel:false && isColumnNotEmpty('topOwnerIncome')">{{ formatNumber(getIncomeByType(2).topOwnerIncome) }}</td>
            </tr>
            
            <!-- 总计 -->
            <tr class="total-row">
              <td>总计</td>
              <td v-if="isColumnNotEmpty('totalIncome')" class="total-highlight">{{ formatNumber(calculateGrandTotal()) }}</td>
              <td v-if="isColumnNotEmpty('parentShare')" class="total-highlight">{{ formatNumber(calculateTotalOwnerIncome()) }}</td>
              <td v-if="list.length>0 ?list[0].isOneLevel:false && isColumnNotEmpty('topOwnerIncome')" class="total-highlight">{{ formatNumber(calculateTotalTopOwnerIncome()) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <Mask v-if="marke"></Mask>
  </div>
</template>
  <script>
  // import { wxqq } from '../utils/utils'
  import Mask from '../components/Mask'
  import routerUtil from '../utils/routerUtil'
  import { Toast } from "vant"
  import moment from 'moment'
  
  export default {
    name: 'twolevel',
    data() {
      return {
        search: '',
        checked: '0',
        incomeType: 0,
        incomeTypes: [
          { text: '全部类型', value: 0 },
          { text: '礼物收益', value: 22 },
          { text: '心动送礼', value: 63 },
          { text: '聊天收益', value: 52 },
          { text: '语音收益', value: 37 },
          { text: '视频收益', value: 55 },
            { text: '邀请充值分成', value: 66 },
        { text: '邀请开通会员分成', value: 74 },
        ],
        timeBegin: 0,
        timeEnd: 0,
        showDatePicker: false,
        datePickerMode: 0,
        datePicker: null,
        minDate: null,
        maxDate: null,
        groupInfo: null,
        searchUid: null,
        searchType: 0,
        loading: false,
        finished: false,
        refreshing: false,
         incomeList: [],
        list: [],
        totalIncome: 0,
        parentComission: 0,
        leaderComission: 0,
        marke: false,
      }
    },
    components: {
      Mask,
    },
    computed: {
      timeBeginDisplay() {
        const date = new Date(this.timeBegin);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
      },
      timeEndDisplay() {
        const date = new Date(this.timeEnd);
        const month = date.getMonth()+1;
        const day = date.getDate();
        return `${date.getFullYear()}/${month > 9 ? month : '0' + month}/${day > 9 ? day : '0' + day}`;
      }
    },
    mounted() {
      if (this.$route.params.userId) {
        this.search = this.$route.params.userId
        this.searchUid = parseInt(this.search);
      }
      this.reqInfo()
      // this.marke = wxqq()
    },
    methods: {
       /**
     * 根据类型获取对应的收益数据
     * @param {Number} type 流水类型：0收益流水 1充值流水 2会员流水
     * @returns {Object} 对应类型的收益数据对象
     */
    getIncomeByType(type) {
  // 验证输入类型
  if (typeof type !== 'number' || type < 0 || type > 2) {
    console.warn(`无效的流水类型: ${type}`);
    return {};
  }

  // 查找匹配的项
  const result = this.incomeList.find(item => item.type === type) || {};
  
 
  
  return result;
},
       formatNumber(num) {
      // 处理空值或无效值
      if (num === undefined || num === null) {
        return '0';
      }
      
      // 转换为数字
      const number = Number(num);
      if (isNaN(number)) {
        return '0';
      }
      
      // 格式化数字，保留两位小数并添加千分位
      return number.toLocaleString('zh-CN', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
    },
    isDiaplay(type){
      if(type.parentShare!=0 || type.totalIncome	!=0 || type.groupOwnerShare!=0 || type.topOwnerIncome!=0)
    {
      return true
    }
    return false
    },
    /**
     * 检查某一列是否有非零值
     * @param {String} columnName 列名：totalIncome、parentShare、topOwnerIncome
     * @returns {Boolean} 该列是否有非零值
     */
    isColumnNotEmpty(columnName) {
      // 检查所有行是否在该列上都为0
      const allZero = this.incomeList.every(item => {
        const value = Number(item[columnName]) || 0;
        return value === 0;
      });
      
      // 如果全部为0，则不显示该列
      return !allZero;
    },
      /**
     * 计算全部总收益
     * @returns {Number} 所有流水类型的总收益合计
     */
    calculateGrandTotal() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalIncome) || 0;

        // if(item.parentShare==0)
        // return sum;
     
        return sum + value;
      }, 0);
    },
    /**
     * 计算邀请分成总和
     * @returns {Number} 所有类型的邀请分成总和
     */
    calculateTotalParentIncome() {
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.totalIncome) || 0;
        return sum + value;
      }, 0);
    },
    
    /**
     * 计算组长分成总和
     * @returns {Number} 所有类型的组长分成总和
     */
   
        calculateTotalTopOwnerIncome() {
        
      return this.incomeList.reduce((sum, item) => {
        console.log(item.topOwnerIncome)
        // 确保数值有效
        const value = Number(item.topOwnerIncome) || 0;
        return sum + value;
      }, 0);
    },
     calculateTotalOwnerIncome() {
     
      return this.incomeList.reduce((sum, item) => {
        // 确保数值有效
        const value = Number(item.parentShare) || 0;
        return sum + value;
      }, 0);
    },
      reqInfo() {
        this.$request.postJson('/api/user/pay_group/info', {})
          .then((res) => {
            if (res.data.code == 0) {
              this.groupInfo = res.data.data;
              if (!this.groupInfo) {
                Toast('暂无推广组信息');
                routerUtil.back()
                return;
              }
              switch (this.groupInfo.period) {
                case 1:
                  this.timeBegin = moment().startOf('day').valueOf();
                  this.timeEnd = moment().endOf('day').valueOf();
                  break;
                case 2:
                  moment
                  this.timeBegin = moment().startOf('isoWeek').valueOf();
                  this.timeEnd = moment().endOf('isoWeek').valueOf();
                  break;
                case 3:
                  this.timeBegin = moment().startOf('month').valueOf();
                  this.timeEnd = moment().endOf('day').valueOf();
                  break;
              }
              this.getList()
              this.getStatistics()
            }
          })
      },
      getList(type) {
        let lastId = ''
        if (type && this.list.length > 0) {
          lastId = this.list[this.list.length - 1].id
        }
        this.$request.postJson('/api/user/pay_group/twoincome_logs', {
          groupId: this.groupInfo.id,
          type: this.searchType,
          userId: this.searchUid == null ? 0 : this.searchUid,
          transType: this.incomeType,
          startTime: this.timeBegin,
          endTime: this.timeEnd,
          lastId: lastId,
          pageSize: 15
        }).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.logs.length == 0) {
              this.loading = false;
              this.refreshing = false
              this.finished = true;
              return
            }
            const uids = [];
            for (let log of res.data.data.logs) {
              uids.push(log.userId);
            }
            this.$request.post('/api/user/info/twouserInfo', { userIds: JSON.stringify(uids) })
              .then((res1) => {
                this.loading = false;
                this.refreshing = false
                if (res1.data.code == 0) {
                  const userMap = new Map();
                  for (let user of res1.data.data.users) {
                   
                      userMap.set(user.userId, user);
                    
                  }
                  for (let log of res.data.data.logs) {
                    log.userInfo = userMap.get(log.userId);
                  }
                  this.list.push(...res.data.data.logs)
                  this.finished = res.data.data.logs.length < 15
                }
              })
          }
        })
      },
      getStatistics() {
        this.$request.postJson('/api/user/pay_group/twoincome_stats', {
          groupId: this.groupInfo.id,
          type: this.searchType,
          userId: this.searchUid == null ? 0 : this.searchUid,
          transType: this.incomeType,
          startTime: this.timeBegin,
          endTime: this.timeEnd,
        }).then((res) => {
          if (res.data.code == 0) {
            this.incomeList=[]
          this.incomeList = res.data.data;
          this.incomeList.forEach(item => { 
            if(item.type==1&& item.parentShare==0)
          {
            

this.incomeTypes.forEach((item,index)=>{
if(item.value==66)
{
  this.incomeTypes.splice(index, 1);
}
})





            
          }
                if(item.type==2&& item.parentShare==0)
          {
            
this.incomeTypes.forEach((item,index)=>{
if(item.value==74)
{
  this.incomeTypes.splice(index, 1);
}
})





            
          }
          });
          }else{
            this.incomeList=[]
          }
        })
      },
      onClickLeft() {
        routerUtil.back()
      },
      onClickRight() {
      },
      onSearch() {
        if (this.search == "") {
          this.searchUid = null
        } else {
          if (isNaN(Number(this.search, 10))) {
            Toast("请输入用户ID")
            return
          }
          const uid = parseInt(this.search);
          this.searchUid = uid;
        }
        this.searchType = parseInt(this.checked)
        this.list = [];
        this.onRefresh()
        this.getStatistics()
      },
      onIncomeTypeChanged() {
        this.list = [];
        this.onRefresh()
        this.getStatistics()
      },
     // 点击开始时间选择器
onTimeBeginTapped() {
  this.datePickerMode = 1;
  this.datePicker = new Date(this.timeBegin || Date.now());
  
  // 核心：开始时间最早为「当前时间-1个月」，最晚为当前时间
  const oneMonthAgo = moment().subtract(1, 'month').toDate(); // 一个月前
  this.minDate = oneMonthAgo;
  this.maxDate = new Date(); // 当前时间
  
  // UI上只显示最近一个月的日期，超出部分置灰
  this.datePickerDisabledDate = (date) => {
    return date < this.minDate || date > this.maxDate;
  };
  
  this.showDatePicker = true;
},

// 点击结束时间选择器
onTimeEndTapped() {
  if (!this.timeBegin) {
    alert('请先选择开始时间');
    return;
  }
  
  this.datePickerMode = 2;
  this.datePicker = new Date(this.timeEnd || this.timeBegin);
  
  // 计算两个上限：开始时间+1个月 和 当天
  const oneMonthLater = moment(this.timeBegin).add(1, 'month').toDate();
  const today = new Date(); // 当天（默认00:00:00，如需包含当天所有时间可改为endOf('day')）
  
  // 结束时间最大可选值为：两者中的较小值（不超过当天，且不超过开始时间+1个月）
  this.minDate = new Date(this.timeBegin);
  this.maxDate = oneMonthLater > today ? today : oneMonthLater;
   this.showDatePicker = true;
  // 禁用超出范围的日期（小于开始时间 或 大于最大限制）
  this.datePickerDisabledDate = (date) => {
    return date < this.minDate || date > this.maxDate;
  };
  
 
},

// 确认选择
onDatePickerConfirm(value) {
  switch (this.datePickerMode) {
    case 1:
      // 开始时间已被UI限制在最近一个月内，直接取值
      this.timeBegin = moment(value).startOf('day').valueOf();
      
      // 自动设置结束时间为开始时间+1个月（不超过开始时间+1个月）
      this.timeEnd = moment(this.timeBegin).add(1, 'month').endOf('day').valueOf();
      break;
      
    case 2:
      // 结束时间限制在开始时间+1个月内
      this.timeEnd = moment(value).endOf('day').valueOf();
 
      if (this.timeEnd > ( moment(this.timeBegin).add(1, 'month').endOf('day').valueOf())) {
        this.timeEnd =  moment(this.timeBegin).add(1, 'month').endOf('day').valueOf();
      }
      break;
  }
  
  this.showDatePicker = false;
  this.datePickerMode = 0;
  this.list = [];
  this.onRefresh();
  this.getStatistics();
},
      onDatePickerCancel() {
        this.datePickerMode = 0;
        this.showDatePicker = false;
      },
      onLoad() {
        this.getList(true)
      },
      onRefresh() {
        // 清空列表数据
        this.finished = false;
  
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.getList()
      },
      getDisplayTime(time) {
        const date = new Date(time);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const hour = date.getHours();
        const min = date.getMinutes();
        const sec = date.getSeconds();
        return `${date.getFullYear()}-${month > 9 ? month : '0' + month}-${day > 9 ? day : '0' + day} ${hour > 9 ? hour : '0' + hour}:${min > 9 ? min : '0' + min}:${sec > 9 ? sec : '0' + sec}`;
      }
    },
  }
  </script>
  <style scoped lang="less">
    /* 全局样式重置 */
    .twolevel-container {
        min-height: 100vh;
        background: #1a1a1a;
        padding-bottom: 20px;
    }
    
    /* 内容包装器 */
    .content-wrapper {
        max-width: 1200px;
        margin: 0 auto;
        padding: 16px;
    }
    
    /* 搜索区域样式 */
    .search-container {
        background: #2a2a2a;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }
    
    .search-btn {
        color: #ffffff;
        font-weight: 500;
        font-size: 16px;
        cursor: pointer;
        transition: color 0.3s ease;
    }
    
    .search-btn:hover {
        color: #e0e0e0;
    }
    
    .search-filters {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 16px;
    }
    
    .radio-group-wrapper {
        flex: 1;
    }
    
    .radio-item {
        font-size: 14px;
        color: #e0e0e0;
        margin-right: 20px;
    }
    
    .dropdown-wrapper {
        flex: 1;
        text-align: right;
    }
    
    /* 日期选择器样式 */
    .date-picker-container {
        display: flex;
        align-items: center;
        margin-top: 16px;
        gap: 8px;
    }
    
    .date-label {
        font-size: 14px;
        color: #e0e0e0;
    }
    
    .date-selector {
        background: #3a3a3a;
        border: 1px solid #5a5a5a;
        border-radius: 8px;
        padding: 8px 12px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.3s ease;
    }
    
    .date-selector:hover {
        background: #4a4a4a;
        border-color: #6a6a6a;
    }
    
    .date-separator {
        color: #888888;
        font-size: 14px;
    }
    
    /* 交易列表样式 */
    .transaction-list {
        background: #2a2a2a;
        border-radius: 12px;
        padding: 16px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }
    
    .transaction-card {
        margin-bottom: 16px;
        padding: 16px;
        background: linear-gradient(135deg, #2a2a2a 0%, #1a1a1a 100%);
        border-radius: 12px;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
        border: 1px solid #3a3a3a;
    }
    
    .transaction-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }
    
    .finance-details {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
    
    .finance-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    
    .finance-label {
        font-size: 14px;
        color: #888888;
    }
    
    .finance-value {
        font-size: 16px;
        font-weight: 600;
    }
    
    .primary-value {
        color: #ffffff;
        font-size: 18px;
    }
    
    .secondary-value {
        color: #e0e0e0;
    }
    
    .tertiary-value {
        color: #cccccc;
    }
    
    .transaction-footer {
        margin-top: 16px;
        padding-top: 12px;
        border-top: 1px solid rgba(255, 255, 255, 0.3);
    }
    
    .transaction-time {
        font-size: 12px;
        color: #666666;
        margin-bottom: 4px;
    }
    
    .transaction-source {
        font-size: 12px;
        color: #888888;
    }
    
    /* 表格样式 */
    .stats-table-container {
      width: 100%;
      padding: 10px;
    }
    
    .stats-table {
      width: 100%;
      border-collapse: collapse;
      background-color: #3a3a3a;
      font-size: 14px;
    }
    
    .stats-table th {
      background-color: #4a4a4a;
      padding: 12px 8px;
      text-align: left;
      font-weight: 500;
      color: #ffffff;
      border-bottom: 1px solid #5a5a5a;
    }
    
    .stats-table td {
      padding: 12px 8px;
      border-bottom: 1px solid #4a4a4a;
      color: #ffffff;
    }
    
    .stats-table tr:last-child td {
      border-bottom: none;
    }
    
    .stats-table .highlight {
      color: #ffffff;
      font-weight: bold;
    }
    
    .stats-table .total-row {
      background-color: #2a2a2a;
    }
    
    .stats-table .total-highlight {
      color: #ffffff;
      font-weight: bold;
      font-size: 16px;
    }
    
    /* 固定在底部的样式 */
    .fixed-bottom {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background-color: #1a1a1a;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
      z-index: 100;
      max-height: 60vh;
      overflow-y: auto;
    }
    
    .transaction-list {
      padding-bottom: 200px;
    }
    
    /* 空状态样式 */
    .empty-state {
      text-align: center;
      padding: 20px;
      color: #888888;
    }
    
    .empty-icon {
      font-size: 40px;
      margin-bottom: 10px;
      color: #666666;
    }
    
    .empty-text {
      font-size: 14px;
      color: #888888;
    }
    
    .stats-container {
        display: grid;
        grid-template-columns: 1fr;
        gap: 16px;
    }
    
    .stat-card {
        background: #2a2a2a;
        border-radius: 12px;
        padding: 20px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }
    
    .stat-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }
    
    .stat-title {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #3a3a3a;
    }
    
    .stat-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 16px;
    }
    
    .stat-item {
        text-align: center;
        padding: 12px;
        background: #3a3a3a;
        border-radius: 8px;
    }
    
    .stat-label {
        font-size: 14px;
        color: #888888;
        margin-bottom: 8px;
    }
    
    .stat-value {
        font-size: 20px;
        font-weight: 600;
        color: #ffffff;
    }
    
    .highlight {
        color: #ffffff;
    }
    
    .total-card {
        background: linear-gradient(135deg, #3a3a3a 0%, #2a2a2a 100%);
        color: white;
    }
    
    .total-card .stat-title {
        color: white;
        border-bottom-color: rgba(255, 255, 255, 0.3);
    }
    
    .total-card .stat-item {
        background: rgba(255, 255, 255, 0.1);
    }
    
    .total-card .stat-label {
        color: rgba(255, 255, 255, 0.9);
    }
    
    .total-card .stat-value {
        color: white;
    }
    
    .total-highlight {
        color: #fff;
        font-size: 24px;
    }
    
    /* 响应式设计 */
    @media (min-width: 768px) {
        .stats-container {
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        }
        
        .stat-grid {
            grid-template-columns: repeat(3, 1fr);
        }
    }
    
    /* Vant 组件样式覆盖 */
    :deep(.van-radio__label) {
        color: #e0e0e0;
    }
    
    :deep(.van-radio__input--checked .van-radio__icon) {
        background-color: #666666 !important;
        border-color: #666666 !important;
    }
    
    :deep(.van-radio__input--checked .van-radio__label) {
        color: #ffffff !important;
    }
    
    :deep(.van-dropdown-menu__title) {
        font-size: 14px;
        color: #ffffff;
    }
    
    :deep(.van-dropdown-menu__bar) {
        background-color: transparent;
    }
    
    :deep(.van-list__loading) {
        padding: 20px 0;
    }
    
    :deep(.van-list__finished-text) {
        color: #666666;
        padding: 20px 0;
    }
    
    /* 动画效果 */
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.3s ease;
    }
    
    .fade-enter-from, .fade-leave-to {
        opacity: 0;
    }
  </style>
  